import { render, staticRenderFns } from "./NumberFormatChain.vue?vue&type=template&id=2a2cbe06"
import script from "./NumberFormatChain.vue?vue&type=script&lang=js"
export * from "./NumberFormatChain.vue?vue&type=script&lang=js"
import style0 from "./NumberFormatChain.vue?vue&type=style&index=0&id=2a2cbe06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports